import initialState from "./initialState";

import appReducer from "./appReducer";
import { LOGOUT_USER, LOGOUT_USER_WITHOUT_API } from "./actionTypes";
import { logoutService } from "../services/loginService";

const reducer = (state = initialState, action) => {
  if (action.type === LOGOUT_USER) {
    const baseURL = process.env.REACT_APP_BASE_URL;
    const userParam = state.userDetails?.userParam;
    const userId = userParam?.userId ?? state?.logoutUserId?.trim();

    if (!!userId) {
      const parsedUserId = window.btoa(userId);
      logoutService(baseURL, {
        userId: parsedUserId,
        id_token: state?.auth?.id_token,
      });
    }
    return appReducer(undefined, action);
  }
  if (action.type === LOGOUT_USER_WITHOUT_API) {
    localStorage.removeItem("DAS_VENDOR_INTERNAL_STATE");
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default reducer;
